// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__72EnE","Body":"Main_Body__5KovP","SidePanel":"Main_SidePanel__F6R1i","Content":"Main_Content__OQiuJ"};